import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AudioWaveform, BookOpen, AlertTriangle, CircleCheckBig } from 'lucide-react';
const bonuses = [{
  emoji: '🎁',
  number: '#1',
  title: 'SOS - Audio-Guía de Rescate Inmediato',
  subtitle: 'Tu salvavidas auditivo para momentos de crisis de ansiedad.',
  description: 'Escucha esta guía cuando sientas el impulso incontrolable de contactarlo. Una voz firme que te ayudará a recuperar el mando en menos de 5 minutos.',
  value: '$7.500',
  icon: AudioWaveform
}, {
  emoji: '🎁',
  number: '#2',
  title: 'Journal Digital - Bitácora de Soberanía',
  subtitle: 'Tu mapa de ruta interactivo para las 72 horas.',
  description: 'Checklists diarios, trackers de dopamina y ejercicios de reescritura de identidad. No navegues sola, usa este mapa para ver tu progreso real.',
  value: '$4.500',
  icon: BookOpen
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function BonusBundle() {
  return <section className="py-32 px-6 bg-charcoal relative border-t border-gold/10 overflow-hidden" data-id="element-16">
      {/* Ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-gold-muted rounded-full blur-[160px] opacity-20 pointer-events-none" data-id="element-17" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-18">
        {/* Section Title */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-19">
          <p className="font-sans text-sm text-gold/70 uppercase tracking-[0.2em] mb-4" data-id="element-20">
            Incluido con tu compra
          </p>
          <h2 className="font-playfair text-3xl sm:text-4xl md:text-5xl font-bold text-metallic-gold leading-tight mb-6 max-w-4xl mx-auto" data-id="element-21">
            LLEVATE ESTOS 2 REGALOS EXCLUSIVOS CON TU COMPRA
          </h2>
          <div className="inline-block bg-gold/10 border border-gold/30 rounded-md px-5 py-2" data-id="element-22">
            <span className="font-sans font-bold text-gold text-sm tracking-widest uppercase" data-id="element-23">
              ⏳ Solo por hoy
            </span>
          </div>
          <div className="w-24 h-[1px] bg-gold mx-auto opacity-50 mt-8" data-id="element-24" />
        </motion.div>

        {/* Bonus Cards */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-25">
          {bonuses.map((bonus, index) => <motion.div key={index} variants={itemVariants} className="bg-card rounded-md border border-gold/25 overflow-hidden group hover:border-gold/50 transition-colors duration-500 relative" data-id="element-26">
              {/* Top accent bar */}
              <div className="h-1 w-full btn-metallic-gold" data-id="element-27" />

              <div className="p-8 sm:p-10" data-id="element-28">
                {/* Icon + Badge row */}
                <div className="flex items-start justify-between mb-6" data-id="element-29">
                  <div className="w-14 h-14 rounded-full bg-gold/10 border border-gold/20 flex items-center justify-center group-hover:bg-gold/15 transition-colors duration-500" data-id="element-30">
                    <bonus.icon className="w-6 h-6 text-gold" strokeWidth={1.5} data-id="element-31" />
                  </div>
                  <div className="bg-gold/10 border border-gold/30 rounded-md px-3 py-1.5" data-id="element-32">
                    <span className="font-sans text-xs font-bold text-gold uppercase tracking-wider" data-id="element-33">
                      Gratis
                    </span>
                  </div>
                </div>

                {/* Title */}
                <h3 className="font-playfair text-xl sm:text-2xl text-white mb-2" data-id="element-34">
                  <span className="mr-2" data-id="element-35">{bonus.emoji}</span>
                  BONO {bonus.number}
                </h3>
                <p className="font-playfair text-lg text-gold mb-3" data-id="element-36">
                  {bonus.title}
                </p>

                {/* Subtitle */}
                <p className="font-sans text-sm text-gray-300 font-medium mb-4 italic" data-id="element-37">
                  {bonus.subtitle}
                </p>

                {/* Description */}
                <p className="font-sans text-gray-400 font-light leading-relaxed mb-6" data-id="element-38">
                  {bonus.description}
                </p>

                {/* Price Tag */}
                <div className="flex items-center gap-3" data-id="element-39">
                  <CircleCheckBig className="w-5 h-5 text-gold flex-shrink-0" strokeWidth={2} data-id="element-40" />
                  <span className="font-sans text-sm text-gray-600 line-through" data-id="element-41">
                    Valorado en {bonus.value}
                  </span>
                  <span className="font-sans text-sm font-bold text-metallic-gold tracking-wide" data-id="element-42">
                    → GRATIS
                  </span>
                </div>
              </div>
            </motion.div>)}
        </motion.div>

        {/* Urgency Banner */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="bg-charcoal-light border border-gold/30 rounded-md p-6 sm:p-8 text-center" data-id="element-43">
          <div className="flex items-center justify-center gap-2 mb-3" data-id="element-44">
            <AlertTriangle className="w-5 h-5 text-gold" strokeWidth={2} data-id="element-45" />
            <span className="font-sans font-extrabold text-gold text-sm uppercase tracking-widest" data-id="element-46">
              Atención
            </span>
            <AlertTriangle className="w-5 h-5 text-gold" strokeWidth={2} data-id="element-47" />
          </div>
          <p className="font-sans text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-48">
            Estos bonos están incluidos{' '}
            <span className="text-white font-semibold" data-id="element-49">SIN COSTO</span> solo si
            ordenas antes de que el cronómetro llegue a cero. No estarán
            disponibles por separado.
          </p>
        </motion.div>
      </div>
    </section>;
}